import React from 'react';
import {Route, Redirect} from 'react-router-dom';

function PrivateRoute({component: Component, ...rest}) {
    let isLoggedIn = localStorage.getItem('userDto') !== null;

    return (
        <Route {...rest} render={props => {
            if (!isLoggedIn) {
                // not logged in so redirect to login page with the return url
                return <Redirect to={{pathname: '/auth/flyersCatalog/signInForm', state: {from: props.location}}}/>
                /*
                if (document.location.pathname.indexOf('flipbookEditor') > -1) {
                    return <Redirect
                        to={{pathname: '/auth/flipbookEditor/signInForm', state: {from: props.location}}}/>
                } else {
                    return <Redirect to={{pathname: '/auth/flyersCatalog/signInForm', state: {from: props.location}}}/>
                }
                */
            }

            // logged in so return component
            return <Component {...props}/>
        }}/>
    );
}

export {PrivateRoute};